import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as S from "./style";
import { FaAngleDown } from "react-icons/fa";
import { FaAngleUp } from "react-icons/fa";
import youtube from "assets/images/icons/youtube.svg";
import instagram from "assets/images/icons/instagram.svg";
import kakaoplus from "assets/images/icons/kakaoplus.svg";
import useWindowSize, { Size } from "hooks/useWindowSize";

function FooterMain() {
  const history = useHistory();
  const { t } = useTranslation();
  const { dataCategoriesTerm } = useSelector(
    (state: any) => state.dataCategoriesTerm
  );
  const [isExpanded, setIsExpanded] = useState<boolean>(true);
  const footerRef = useRef<HTMLDivElement>(null);
  const size: Size = useWindowSize();
  const isTabMobile = size.width && size.width <= 1024;

  const handleExpand = () => {
    setIsExpanded((prev) => !prev);

    if (footerRef.current) {
      const resizeObserver = new ResizeObserver(() => {
        footerRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      });

      resizeObserver.observe(footerRef.current);

      return () => {
        if (footerRef.current) {
          resizeObserver.unobserve(footerRef.current);
        }
      };
    }
  };

  return (
    <S.Wrapper id="footer" ref={footerRef}>
      <S.Container>
        <div className="title" onClick={handleExpand}>
          COMPANY INFO{" "}
          <S.ExpandButton>
            {isExpanded ? <FaAngleUp /> : <FaAngleDown />}
          </S.ExpandButton>
        </div>
    
        <S.CollapseWrapper isExpanded={isExpanded}>
          <div className="step">
            <S.Box>
              <div className="item">
                <span className="value">(주)열매컴퍼니</span>
              </div>
              <div className="item">
                <span className="value">|</span>
              </div>
              <div className="item">
                <span className="key">대표자 </span>
                <span className="value">김재욱 </span>
              </div>
              <div className="item">
                <span className="value">|</span>
              </div>
              <div className="item">
                <span className="key">사업자등록번호 </span>
                <span className="value">664-88-00573</span>
              </div>
            </S.Box>
            <S.Box className="mt-18">
              <div className="item">
                <span className="key">통신판매업 신고번호 </span>
                <span className="value">2021-충남아산-0558호</span>
              </div>
              <div className="item">
                <span className="value">|</span>
              </div>
              <div className="item">
                <span className="key">개인정보관리책임자 </span>
                <span className="value">김재욱</span>
              </div>
            </S.Box>
            <S.SubBox>
              <div className="title">주소</div>
              <div className="item">
                <span className="key">서울 </span>
                <span className="value">
                  06182 서울 강남구 영동대로 407, 코니빌딩 4층
                </span>
              </div>
              <div className="item">
                <span className="key">충남 </span>
                <span className="value">
                  31470 충남 아산시 배방읍 희망로46번길 45-11, 405호
                </span>
              </div>
            </S.SubBox>
          </div>
          <div className="step">
            <S.Box>
              <div className="item">
                <span className="key">Company Mail (사업제휴 / 회사문의) </span>
                <span className="value">info@artnguide.com</span>
              </div>
            </S.Box>
            <S.Box>
              <div className="item">
                <span className="key">고객문의 </span>
                <span className="value">
                  cs@artnguide.com / 070-5015-0772 , 0773
                </span>
              </div>
            </S.Box>
            <S.Box>
              <div className="item">
                <span className="value">
                  * 주말 및 공휴일에는 상담이 어렵습니다
                </span>
              </div>
            </S.Box>
            <S.SubBox>
              <div className="title">운영시간 </div>
              <div className="item">
                <span className="value">
                  평일 10:00 ~ 18:00
                  <br /> (점심시간 12:00~13:00)
                </span>
              </div>
            </S.SubBox>
          </div>
        </S.CollapseWrapper>
      </S.Container>

      <S.ContainerTerm>
        {isTabMobile ? (
          <div className="mobile-wrapper">
            <div className="sns">
              <img
                src={youtube}
                onClick={() =>
                  window.open("https://www.youtube.com/@Artnguide", "_blank")
                }
              ></img>
              <img
                src={instagram}
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/artnguide?igsh=YXM1Mjdhb20wMng2",
                    "_blank"
                  )
                }
              ></img>
              <img
                src={kakaoplus}
                onClick={() =>
                  window.open("https://pf.kakao.com/_ixgPNj", "_blank")
                }
              ></img>
            </div>
            <div className="container-term-list">
              <div className="item">
                {dataCategoriesTerm?.map((dt: any, i: any) => (
                  <div className="term" key={i}>
                    <div onClick={() => history.push(dt.location)}>
                      {dt.title}
                    </div>
                    {i !== dataCategoriesTerm.length - 1 ? <div>|</div> : null}
                  </div>
                ))}
              </div>
              <S.TextMin>© Yeolmaecompany. all rights reserved</S.TextMin>
            </div>
          </div>
        ) : (
          <div className="wrapper">
            <div className="container-term-list">
              <div className="item">
                {dataCategoriesTerm?.map((dt: any, i: any) => (
                  <div className="term" key={i}>
                    <div onClick={() => history.push(dt.location)}>
                      {dt.title}
                    </div>
                    {i !== dataCategoriesTerm.length - 1 ? <div>|</div> : null}
                  </div>
                ))}
              </div>
              <S.TextMin>© Yeolmaecompany. all rights reserved</S.TextMin>
            </div>
            <div className="sns">
              <img
                src={youtube}
                onClick={() =>
                  window.open("https://www.youtube.com/@Artnguide", "_blank")
                }
              ></img>
              <img
                src={instagram}
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/artnguide?igsh=YXM1Mjdhb20wMng2",
                    "_blank"
                  )
                }
              ></img>
              <img
                src={kakaoplus}
                onClick={() =>
                  window.open("https://pf.kakao.com/_ixgPNj", "_blank")
                }
              ></img>
            </div>
          </div>
        )}
      </S.ContainerTerm>
    </S.Wrapper>
  );
}
export default FooterMain;
